var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5708 3.80066H10.6579V1.96183C10.1316 1.9071 9.6027 1.88008 9.07351 1.88088C7.50067 1.88088 6.42513 2.84077 6.42513 4.59865V6.11366H4.6499V8.17223H6.42513V13.4459H8.55308V8.17223H10.3225L10.5885 6.11366H8.55308V4.80104C8.55308 4.19387 8.71499 3.80066 9.5708 3.80066Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.84df4f83e351bf5b94eb68c079f48807.svg";
export { ForwardRef as ReactComponent };